import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import InfoBox from 'components/Shared/InfoBox'
import Input from 'components/Shared/Input'
import {
  useCampaignSetup,
  useCampaignSetupDispatch,
} from 'components/Recommendations/Campaign/Context/CampaignSetupContext'
import PlatformLabel from 'components/Shared/PlatformLabel'

export default function Payer({ recommendation, disabled = false, bothSelected = false }) {
  const { t } = useTranslation()
  const { setup } = useCampaignSetup()
  const { updateDsaFields } = useCampaignSetupDispatch()

  const payer = setup?.dsa_payor ?? recommendation

  return (
    <div className="field-wrapper">
      <div className="platform-label-wrapper">
        <InfoBox content="Tips.Recommendations.payer">
          <span className="field-title">{t('Recommendations.summary.advancedSettings.payer.title')}</span>
        </InfoBox>

        <PlatformLabel platform={'meta'} bothSelected={bothSelected} />
      </div>

      <Input
        value={payer}
        onChange={(e) => {
          const value = e.target.value
          updateDsaFields({ dsa_payor: value })
        }}
        wrapperClass="mb-0 w-100"
        disabled={disabled}
      />
    </div>
  )
}

Payer.propTypes = {
  recommendation: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}